import { makeStyles, tokens } from "@fluentui/react-components";
import { ReactNode } from "react";

const useStyles = makeStyles({
  root: {
    width: "100%",
    boxSizing: "border-box",
    maxWidth: "1900px",
    minWidth: 0,
    margin: "0 auto",
    paddingLeft: tokens.spacingVerticalM,
    paddingRight: tokens.spacingVerticalM,
  },
});

interface ConstrainedContentProps {
  children: ReactNode;
}

export const ConstrainedContent = ({ children }: ConstrainedContentProps) => {
  const classes = useStyles();

  return <div className={classes.root}>{children}</div>;
};
